import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { APOLLO_STARGATE_CONTEXT_ROOT } from '@atlassian/jira-servicedesk-knowledge-services/src/services/rest/constants';
import type { OrderCategoriesRequest, CategoryReorderResponse } from '../types';

export const orderCategories = ({
	projectId,
	activationId,
	categories,
	apolloPath = APOLLO_STARGATE_CONTEXT_ROOT,
}: OrderCategoriesRequest): Promise<CategoryReorderResponse> => {
	const url = `${apolloPath}/${activationId}/api/project/${projectId}/category/order`;

	return fetchJson(url, {
		method: 'PUT',
		body: JSON.stringify(categories),
	});
};
